/**
 * react-i18next 設定
 *
 * 多言語対応のための設定ファイル。
 * 日本語・英語の翻訳リソースを読み込み、i18nextを初期化します。
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './locales/ja.json';
import en from './locales/en.json';

/**
 * i18next初期化
 *
 * - デフォルト言語: 日本語 (ja)
 * - フォールバック言語: 日本語 (ja)
 * - 言語の自動検出は無効化（language-storeで管理）
 */
i18n.use(initReactI18next).init({
  resources: {
    ja: {
      translation: ja,
    },
    en: {
      translation: en,
    },
  },
  lng: 'ja', // デフォルト言語
  fallbackLng: 'ja', // フォールバック言語
  interpolation: {
    escapeValue: false, // Reactは既にXSS対策済み
  },
  react: {
    useSuspense: false, // Suspenseを無効化（オプション）
  },
});

export default i18n;
